import { Card, CardMedia, Grid, Typography } from '@mui/material';
import { allBlogs } from '../../siteData/Blogs';
import { useNavigate } from 'react-router-dom';
import SEO from '../../components/SEO/SEO';

const Blogs = () => {
  const navigate = useNavigate();
  const handleCardClick = (blog) => {
    navigate(`/blog/${blog.id}`);
  };
  return (
    <>
      <SEO
        title='Mudrost Studio – Expert Food & Product Photography, Videography in Bangalore'
        description='Expert tips on food & product photography, videography, and brand storytelling. Behind-the-scenes, creative techniques & industry trends.'
        itempropDescription='Mudrost Studio – Bangalore’s top creative studio for food photography, product photography, and high-end brand videography.'
        keywords='food photography Bangalore, product photography Bangalore, commercial photography studio, food videography Bangalore, product videography services, ad film production Bangalore'
        url='https://mudrost.in/blog'
      />
      <Grid container columnSpacing={4} rowSpacing={4} sx={{ p: { xs: '30px', sm: '30px', md: '40px' } }}>
        {allBlogs.map(({ thumbnail, thumbnailAltText, isFeatured, banner, title }, bIndex) => (
          <>
            {isFeatured ? (
              <Grid item md={12} sm={12}>
                <Card
                  raised={false}
                  sx={{ borderRadius: '20px', cursor: 'pointer' }}
                  onClick={() => handleCardClick(allBlogs[bIndex])}
                >
                  <CardMedia
                    component='img'
                    image={banner}
                    alt={thumbnailAltText}
                    sx={{ height: { md: '600px', xs: 'auto', sm: 'auto' } }}
                  />
                </Card>
                <Typography
                  variant='h3'
                  sx={{
                    p: '20px 10px',
                    fontSize: { md: '28px', sm: '16px', xs: '16px' },
                    fontWeight: { sm: 'bold', xs: 'bold', md: 'auto' },
                    lineHeight: '20px !important'
                  }}
                >
                  {title}
                </Typography>
              </Grid>
            ) : (
              <Grid item md={4} sm={12} xs={12}>
                <Card
                  raised={false}
                  sx={{ borderRadius: '20px', cursor: 'pointer' }}
                  onClick={() => handleCardClick(allBlogs[bIndex])}
                >
                  <CardMedia component='img' image={thumbnail} alt={thumbnailAltText} />
                </Card>
                <Typography variant='h6' sx={{ p: '10px', lineHeight: '20px  !important' }}>
                  {title}
                </Typography>
              </Grid>
            )}
          </>
        ))}
      </Grid>
    </>
  );
};

export default Blogs;
